export enum SerpStatusGq {
  COMPLETED = 'COMPLETED',
  PROCESSING = 'PROCESSING',
  NOT_ENABLED = 'NOT_ENABLED',
}

export function SerpStatusToString(serpStatus: SerpStatusGq): string {
  if (serpStatus === SerpStatusGq.COMPLETED) {
    return 'completed';
  }
  if (serpStatus === SerpStatusGq.PROCESSING) {
    return 'processing';
  }
  return 'N/A';
}
